<!--
 * @Description: 首页相关配置
 * @Author: 
 * @Date: 2022-12-28 11:41:16
 * @LastEditTime: 2023-02-23 10:30:42
 * @LastEditors: dongqianqian
 * @Usage: 
-->

<template>
  <div>
    <header>
      模块名称：
      <el-input
        v-model="moduleName"
        placeholder="请输入模块名称"
        style="width: 340px"
      ></el-input>
      模块权限：
      <el-select
        v-model="moduleLevel"
        placeholder="请选择"
      >
        <el-option
          label="全部"
          :value="-1"
        > </el-option>
        <el-option
          label="项目"
          value="0"
        > </el-option>
        <el-option
          label="公司"
          value="1"
        > </el-option>
      </el-select>
      状态：
      <el-select
        v-model="moduleStatus"
        placeholder="请选择"
      >
        <el-option
          label="全部"
          :value="-1"
        > </el-option>
        <el-option
          label="启用"
          value="0"
        > </el-option>
        <el-option
          label="禁用"
          value="1"
        > </el-option>
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        style="margin-left: 10px"
        @click="handleCurrentChange(1)"
      >查询</el-button>
      <el-button
        type="primary"
        @click="openAdd"
      >新增</el-button>
    </header>
    <el-table
      :data="tableData"
      style="width: 100%;margin-top: 20px;"
      border
    >
      <el-table-column
        prop="moduleName"
        label="模块名称"
      >
      </el-table-column>
      <el-table-column label="模块图片">
        <template slot-scope="scope">
          <img
            :src="baseUrl + scope.row.moduleImg"
            class="home-img"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="moduleSort"
        label="模块排序"
        sortable
        width="200"
      >
      </el-table-column>
      <el-table-column
        label="模块权限"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          {{scope.row.moduleLevel == 0 ?'项目':'公司'}}
        </template>
      </el-table-column>
      <el-table-column
        label="状态"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          {{scope.row.isDelete == 0 ?'启用':'禁用'}}
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="200"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="edit(scope.row)"
          >编辑</el-button>
          <el-button
            type="text"
            @click="del(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div
      class="tc"
      style="margin-top:20px"
    >
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[ 10, 20, 50]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      >
      </el-pagination>
    </div>
    <el-dialog
      :title="editId?'编辑':'新增'"
      :visible.sync="addDialogVisible"
      width="600px"
      center
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <el-form
        ref="ruleForm"
        :model="form"
        label-width="120px"
        :rules="rules"
      >

        <el-form-item
          label="模块名称:"
          prop="moduleName"
        >
          <el-input v-model="form.moduleName"></el-input>
        </el-form-item>
        <el-form-item
          label="模块图片:"
          prop="moduleImg"
        >
          <el-input v-model="form.moduleImg"></el-input>
          <el-upload
            style="display:inline-block;"
            action=""
            :auto-upload="true"
            :http-request="uploadImg"
            :file-list="fileList"
            :before-upload="beforeAvatarUpload"
            :on-change="handleChange"
            list-type="picture"
            :on-remove="handleRemove"
          >
            <el-button
              size="small"
              type="primary"
            >上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item
          label="跳转链接:"
          prop="jumpLinkUrl"
        >
          <el-input v-model="form.jumpLinkUrl"></el-input>
        </el-form-item>
        <el-form-item
          label="模块排序:"
          prop="moduleSort"
        >
          <el-input v-model="form.moduleSort"></el-input>
        </el-form-item>
        <el-form-item
          label="模块组件:"
          prop="component"
        >
          <el-input v-model="form.component"></el-input>
        </el-form-item>
        <el-form-item label="当前环境:">
          <el-input
            v-model="form.moduleSetting"
            placeholder="服务器标识，例如：cs、wx、xk等"
          ></el-input>
        </el-form-item>
        <el-form-item label="模块权限:">
          <el-radio
            v-model="form.moduleLevel"
            :label="0"
          >项目</el-radio>
          <el-radio
            v-model="form.moduleLevel"
            :label="1"
          >公司</el-radio>
        </el-form-item>
        <el-form-item label="有效状态:">
          <el-radio
            v-model="form.isDelete"
            :label="0"
          >启用</el-radio>
          <el-radio
            v-model="form.isDelete"
            :label="1"
          >禁用</el-radio>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
          >确定</el-button>
          <el-button @click="resetForm('ruleForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  provinceAndCityData
} from 'element-china-area-data'
import {
  Api_SuperAdmin,
  Api_Base
} from "@/api/api";
import { BASE_PLATFORMLOGO_URL } from '@/util/constant'
export default {
  data() {
    return {
      options: provinceAndCityData,
      selectedOptions: [],
      searchKey: "",
      status: -1,
      menuName: '',
      tableData: [],
      addDialogVisible: false,
      form: {
        moduleName: '', // 模块名称
        moduleSort: '',// 模块排序
        jumpLinkUrl: '',   //跳转链接
        moduleImg: '', // 模块图片地址
        component: '', // 模块组件
        moduleSetting: '', // 标识当前环境，用来首页给工程资料传值使用
        isDelete: 0, //  1 禁用  0启用
        moduleLevel: 0,//1公司，0项目
      },
      rules: {
        moduleName: [{
          required: true,
          message: "请输入模块名称",
          trigger: "blur",
        }],
        moduleSort: [{
          required: true,
          message: "请输入模块顺序",
          trigger: "blur",
        }],
        moduleImg: [{
          required: true,
          message: "请上传图片",
          trigger: "blur",
        }],
        component: [{
          required: true,
          message: "请选择模块组件",
          trigger: "blur",
        }],
      },
      totalCount: 0,
      currentPage: 1,
      pagesize: 10,
      operateList: [],
      fileList: [],
      editId: 0,
      moduleName: '',
      moduleStatus: -1,
      moduleLevel: -1,
      baseUrl: BASE_PLATFORMLOGO_URL,
    };
  },
  created() {
    this.getList()
  },
  methods: {
    uploadImg(params) {
      var formData = new FormData();
      formData.append("files", params.file);
      Api_Base.upLoadFileFunction(1, formData).then(res => {
        if (res.data.data[0].fileUrl) {
          this.form.moduleImg = res.data.data[0].fileUrl
          this.$message({
            type: "success",
            message: "上传成功!",
          });
        }
      })
    },
    beforeAvatarUpload(file) {
      const typeArr = ["image/png", "image/gif", "image/jpeg", "image/jpg"];
      const isJPG = typeArr.indexOf(file.type) !== -1;
      const isLt3M = file.size / 1024 / 1024 < 3;
      if (!isJPG) {
        this.$message.error("只能上传图片!");
      }
      if (!isLt3M) {
        this.$message.error("上传头像图片大小不能超过 3MB!");
      }
      return isJPG && isLt3M;
    },
    handleChange(file, fileList) {
      this.fileList = [];
      this.fileList.push(file);
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      this.form.moduleImg = ''
    },
    handleClose() {
      this.resetForm('ruleForm')
    },
    openAdd() {
      this.addDialogVisible = true
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].resetFields();
      }
      this.fileList = [];
      this.clear()
    },
    clear() {
      this.form = {
        moduleName: '', // 模块名称
        moduleSort: '',// 模块排序
        jumpLinkUrl: '',   //跳转链接
        moduleImg: '', // 模块图片地址
        component: '', // 模块组件
        moduleSetting: '', // 标识当前环境，用来首页给工程资料传值使用
        isDelete: 0, //  1 禁用  0启用
        moduleLevel: 0,//1公司，0项目
      }
    },
    edit(item) {
      this.fileList = []
      this.addDialogVisible = true;
      this.editId = item.id
      this.form = item
      this.fileList.push({ url: BASE_PLATFORMLOGO_URL + item.moduleImg })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.add();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.addDialogVisible = false;
      // this.$refs[formName].resetFields();
      this.editId = 0
    },
    del(item) {
      this.$confirm("是否删除此条数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        Api_SuperAdmin.delHome(item.id).then((res) => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.getList();
        });
      });
    },
    add() {
      let item = this.form
      Api_SuperAdmin.editHome(item).then(res => {
        if (res.data.data) {
          this.$message({
            type: "success",
            message: "更新成功!",
          });
          this.addDialogVisible = false;
          this.getList();
        } else {
          this.$message({
            type: "error",
            message: "更新失败",
          });
        }
      })
    },
    getList() {
      const params = {
        pageSize: this.pagesize,
        pageIndex: this.currentPage,
        name: this.moduleName,
        isDelete: this.moduleStatus,
        moduleLevel: Number(this.moduleLevel)
      }
      Api_SuperAdmin.getHomeList(params).then(res => {
        const { data } = res
        if (data.statusCode === 200) {
          this.tableData = data.data.tList
          this.totalCount = data.data.totalCount
        }
      })
    },
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    handleClick(val) {
      this.form.parentId = val.id
      this.addDialogVisible = true;
    }
  },
};
</script>
<style lang="scss" scoped>
.home-img {
  height: 55px;
}
</style>